import type { TMessages } from '@/types/TMessages'

export const messages = {
  buttons: {
    close: 'Закрыть',
    to_finance: 'К заявке',
  },
} satisfies TMessages
